import { render, staticRenderFns } from "./VoyageReportView.vue?vue&type=template&id=23d3b34a&scoped=true&"
import script from "./VoyageReportView.vue?vue&type=script&lang=js&"
export * from "./VoyageReportView.vue?vue&type=script&lang=js&"
import style0 from "./VoyageReportView.vue?vue&type=style&index=0&id=23d3b34a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3b34a",
  null
  
)

export default component.exports